





























































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Ultrassom } from '../../../../back/src/entity/Ultrassom';

import {
  placentaLocalizacaoStrings,
  normalAlteradoStrings,
  apresentacaoFetalStrings,
  sexoBebeStrings,
  tipoPartoStrings,
} from '../../utils/constants';
import { TipoParto } from '../../../../back/src/types';
import { calculoIdadeGestacional } from '../../utils/functions';

export default Vue.extend({
  name: 'UltrassonsDeGestacaoCard',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
    gestacao: {
      type: Object as () => Gestacao,
    },
    ultrassons: {
      type: Array as () => Ultrassom[],
    },
    show: {
      default: false,
    },
    gestacaoAtual: {
      default: false,
    },
  },
  data() {
    return {
      sortDesc: false,
      showUltrassons: true,
      placentaLocalizacaoStrings,
      normalAlteradoStrings,
      apresentacaoFetalStrings,
      sexoBebeStrings,
    };
  },
  computed: {
    tituloGestacao(): string {
      if (!this.gestacao) {
        return 'Sem gestação associada';
      }
      if (this.paciente.gestacao_atual && this.paciente.gestacao_atual.id === this.gestacao.id) {
        return 'Gestação atual';
      }
      const momentDataParto = moment(this.gestacao.data_parto);
      const dataParto = momentDataParto.isValid() ? momentDataParto.format('DD/MM/YYYY') : '';
      const tipoParto = _.has(tipoPartoStrings, this.gestacao.tipo_parto)
        ? ` - ${tipoPartoStrings[this.gestacao.tipo_parto]}`
        : '';
      let nomeBebes = '';
      if (this.gestacao.tipo_parto === TipoParto.N || this.gestacao.tipo_parto === TipoParto.C) {
        nomeBebes = ` - ${this.gestacao.nome1}${this.gestacao.nome2 ? ` & ${this.gestacao.nome2}` : ''}`;
      }
      return `Gestação anterior (${dataParto}${tipoParto}${nomeBebes})`;
    },
    gemelar() {
      return this.gestacao ? this.gestacao.gestacao_gemelar : false;
    },
    ultrassonsSorted(): Ultrassom[] {
      return _.orderBy(
        this.ultrassons as Ultrassom[],
        ['data_ultrassom'],
        [this.sortDesc ? 'desc' : 'asc'],
      );
    },
    headers() {
      return [
        {
          value: 'data_ultrassom',
          text: 'Data ',
          class: 'text-no-wrap pl-2',
          sortable: true,
        },
        {
          value: 'ig_laudada',
          text: 'IG laudada',
          class: 'text-no-wrap text-center',
          align: 'center',
        },
        {
          value: 'ig',
          text: 'IG oficial',
          class: 'text-no-wrap text-center',
          align: 'center',
        },
        {
          value: 'placenta_localizacao',
          text: 'Localização',
          class: 'text-no-wrap text-center',
          align: 'center',
        },
        {
          value: 'placenta_grau',
          text: 'Grau plac.',
          class: 'text-no-wrap text-center',
          align: 'center',
        },
        // bebe
        {
          value: 'apres_fetal1',
          text: 'Apresent.',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'ila1',
          text: 'ILA (mm)',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'morfologia1',
          text: 'Morfologia',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'sexo1',
          text: 'Sexo',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'peso_gramas1',
          text: 'Peso (g)',
          class: 'text-no-wrap text-center',
        },
        {
          value: 'doppler1',
          text: 'Doppler',
          class: 'text-no-wrap text-center',
        },
        {
          value: '',
          text: 'Ações',
          class: 'text-no-wrap text-center',
        },
      ];
    },
  },
  mounted() {
    this.showUltrassons = !!this.gestacaoAtual;
  },
  methods: {
    stripedRow(index: number): string {
      if (Number(index) % 2 === 0) {
        return 'grey lighten-3';
      }
      return '';
    },
    formatarData(data) {
      if (!data) {
        return '-';
      }
      return moment(data).format('DD/MM/YYYY');
    },
    intToString(val: string | null) {
      if (val === null) {
        return '';
      }
      return val.toString();
    },
    idadeGestacional(gestacao: Gestacao, ultrassom: Ultrassom): string {
      return calculoIdadeGestacional(
        gestacao,
        ultrassom.data_ultrassom,
        false,
      );
    },
    idadeGestacionalUltrassom(ultrassom: Ultrassom): string {
      let igString = '';
      if (!!ultrassom.ig_semanas && ultrassom.ig_semanas > 0) {
        igString = igString.concat(`${ultrassom.ig_semanas}`);
      }
      if (!!ultrassom.ig_dias && ultrassom.ig_dias > 0) {
        igString = igString.concat(` ${ultrassom.ig_dias}/7 `);
      }
      return igString;
    },
    pesoFormatado(pesoGramas: number): string {
      if (pesoGramas) {
        return `${new Intl.NumberFormat('pt-BR').format(pesoGramas)}`;
      }
      return '';
    },
  },
});
